import React from "react";
import somesh from "../assets/somesh.jpeg";
export default function Developer() {
    return (
        <div
            className="dev"
            style={{
                minHeight: "fit-content",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                background: "linear-gradient(-45deg, #f8fffc 0%, #e0f7fa 50%, #d0f8e8 100%)",
                fontFamily: "Segoe UI, Roboto, Arial, sans-serif",
                padding: "60px 0",
                borderRadius: 22
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: 24,
                    boxShadow: "0 8px 32px 0 rgba(34,100,58,0.12), 0 2px 8px 0 rgba(34,100,58,0.08)",
                    padding: "48px 36px 36px 36px",
                    maxWidth: 400,
                    width: "100%",
                    textAlign: "center"
                }}
            >
                <img
                    src={somesh}
                    alt="Somesh Raichandani"
                    style={{
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        objectFit: "cover",
                        marginBottom: 24,
                        boxShadow: "0 2px 12px #b2bec3",
                        border: "4px solid #43e97b22"
                    }}
                />
                <h2
                    style={{
                        margin: 0,
                        fontSize: 30,
                        fontWeight: 700,
                        color: "#22643a",
                        letterSpacing: 1.2
                    }}
                >
                    Somesh Raichandani
                </h2>
                <div
                    style={{
                        color: "#555",
                        fontSize: 18,
                        margin: "18px 0 2px 0",
                        lineHeight: 1.7
                    }}
                >
                    Hi, I'm a web developer who loves building beautiful, user-focused web experiences.
                    <br />
                    <br />
                    I am working on this project to contribute to the health and wellness of everyone.
                    <br />
                    <br />
                    <span className="feel-free" style={{ color: "#43e97b", fontWeight: 600 }}>
                        {" "}
                        Feel free to connect with me @
                    </span>
                </div>
                <a
                    className="mail-btn"
                    href="mailto:someshraichandani1@gmail.com"
                    style={{
                        display: "inline-block",
                        padding: "12px 28px",
                        background: "linear-gradient(90deg, #43e97b 0%, #38f9d7 100%)",
                        color: "#fff",
                        borderRadius: 30,
                        fontWeight: 600,
                        fontSize: 17,
                        textDecoration: "none",
                        boxShadow: "0 2px 8px #43e97b44",
                        transition: "background 0.2s",
                        marginTop: 0
                    }}
                >
                    someshraichandani1@gmail.com
                </a>
            </div>
        </div>
    );
}
